
















import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
@Component
export default class BusinessCentralLoader extends Vue {
    @Prop() target!: string;
    @Ref('bc') bc!: HTMLIFrameElement;
    contentLoaded: boolean = false;
    iframeTarget: string = '';
    created() {
        this.authenticate();
    }

    iframeContentLoaded() {
        console.log('iframe loaded');
        this.contentLoaded = true;
    }

    delayedReveal() {
        setTimeout(() => {
            this.contentLoaded = true;
        }, 2000);
    }

    authenticate() {
        const path = `/api/everyday/businesscentral/redirecting`;
        console.log('path', path);
        const requestContext = (window as any).__litium.requestContext;
        this.contentLoaded = false;
        fetch(path, {
            method: 'get',
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(authToken => {
                        this.iframeTarget = this.mergeUrl(authToken);
                        this.delayedReveal();
                    });
                } else {
                    console.error('Failed to authenticate');
                }
            })
            .catch(error => {
                console.error('Failed to authenticate', error);
            });
    }

    mergeUrl(token: string): string {
        var url: string = '';

        if (this.target.indexOf('?') > 0) {
            url = this.target + '&auth_token=' + token;
        } else {
            url = this.target + '?auth_token=' + token;
        }

        console.log('url', url);

        return url;
    }
}
